import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material"
import { LoadingIcon } from "components/Common/LoadingIcon"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import lessonService from "services/lessonService"
import { setCurrentLesson, setLessons } from "slices/lessonSlice"
import type { IChapter } from "types/chapterTypes"
import type { ILesson } from "types/lessonTypes"
import { LessonCardMenu } from "./LessonCardMenu"

type Props = {
  chapter: IChapter
}

export function LessonList({ chapter }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  const lessons = useAppSelector((state) => state.lesson.lessons)

  useEffect(() => {
    if (lessons.length === 0) {
      setIsLoading(true)
    }

    lessonService
      .getChapterLessons(chapter.id)
      .then((lessons) => {
        dispatch(setLessons(lessons))
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [chapter.id, dispatch, lessons.length])

  const handleClickLesson = (lesson: ILesson) => {
    dispatch(setCurrentLesson(lesson))
  }

  return (
    <>
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <Grid container spacing={2}>
          {lessons.map((lesson) => (
            <Grid key={lesson.id} item lg={4} md={6} xs={12}>
              <Card>
                <CardHeader
                  action={<LessonCardMenu lesson={lesson} />}
                  title={lesson.id}
                  titleTypographyProps={{ variant: "body2" }}
                ></CardHeader>
                <CardActionArea onClick={() => handleClickLesson(lesson)}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={lesson.imageUrl}
                    alt="Paella dish"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {lesson.name}
                    </Typography>
                    <Typography variant="body2" color="text.primary">
                      {lesson.type}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {lesson.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  )
}
